export const toBlob = (base64 , type)=> {
  let bin = atob(base64.replace(/^.*,/, ''));
  let buffer = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }
  return new Blob([buffer.buffer], {
    type: type === null ? 'image/png' : type
  });
};

export const toFormData = file => {
  let formData = new FormData();
  return formData.append("data", file);
};


export default {
  toBlob,
  toFormData
};
